import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {MailTempType} from "@pages/email/common/Constant";
import UpdateFullMailTemplateModal from "@pages/email/template/edit/UpdateFullMailTemplateModal";
import FullMailBasicInfo from "@pages/email/common/view/FullMailBasicInfo";
import FullMailSubjectTemp from "@pages/email/common/view/FullMailSubjectTemp";
import FullMailBodyTemplateTabs from "@pages/email/common/view/FullMailBodyTemplateTabs";
import FullMailChooseYourSignatures from "@pages/email/common/view/FullMailChooseYourSignatures";
import FullMailChooseYourEmails from "@pages/email/common/view/FullMailChooseYourEmails";
import JobPipeLineList from "@pages/jobpipeline/list/JobPipeLineList";

const SearchUVRunJobPipelineModal = (props) => {
    const [jobId, setJobId] = useState("");

    const {runJob, isShow, onClose} = props


    useEffect(() => {
        if (runJob) {
            setJobId(runJob.job_id)
        }
    }, [runJob]);

    return (
        <>
            <Modal show={isShow}
                   fullscreen
                   size={'xl'}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>
                        {'Search UV'}
                    </Modal.Title>
                    <div className={"row"}>
                        <Button variant='secondary' onClick={() => onClose()}>
                            Close
                        </Button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <JobPipeLineList jobId={jobId} showFullSearch/>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SearchUVRunJobPipelineModal;
